import * as moment from 'moment';
import { useMemo } from 'react';
import { AgGridReact } from 'ag-grid-react';
import { GridWrapper } from './styles';
import { ColDef, FirstDataRenderedEvent, GridReadyEvent, ICellRendererParams, IHeaderParams, RowDataChangedEvent, SortChangedEvent, ValueGetterParams } from 'ag-grid-community';
import SortableHeaderComponent from '@nkr/views/admin/center/list/common/sortable-header';
import { ILateRexmCompliance } from '@nkr/models/index';
import { Glyphicon, OverlayTrigger, Popover } from 'react-bootstrap';
import ReactHtmlParser from 'react-html-parser';

interface IProps {
    data: ILateRexmCompliance[]
}

export const Grid = (props: IProps) => {
    const getOverlay = (id: number) => {
        let item = props.data.find(x => x.id == id);

        console.log(item);

        return (
            <Popover>
                {ReactHtmlParser(item != null ? item.responseDetails : '')}
            </Popover>
        );
    };

    const onGridReady = (e: GridReadyEvent) => {
        e.api.sizeColumnsToFit();
    };

    const onFirstDataRendered = (e: FirstDataRenderedEvent) => {
        e.api.sizeColumnsToFit();
    };

    const onRowDataChanged = (e: RowDataChangedEvent) => {
        e.api.sizeColumnsToFit();
    };

    const onSortChanged = (e: SortChangedEvent) => {
        e.api.sizeColumnsToFit();

        e.api.refreshCells();
    };

    const reportColumns: ColDef[] = [
        {
            colId: 'Rank',
            field: 'rank',
            headerComponentFramework: (props: IHeaderParams) =>
                <SortableHeaderComponent {...props}>
                    R#
                </SortableHeaderComponent>,
            headerName: 'Rank',
            width: 55,
            cellClass: 'center-list-cell',
            headerClass: 'list-header-no-border',
            resizable: true,
            suppressSizeToFit: true,
            valueGetter: (props: ValueGetterParams) => props.node.rowIndex + 1
        },
        {
            colId: 'donorCenterAlias',
            field: 'donorCenterAlias',
            headerName: 'Donor Center',
            cellClass: 'center-list-cell',
            headerClass: 'list-header-left',
            headerComponentFramework: (props: IHeaderParams) =>
                <SortableHeaderComponent {...props}>
                    Donor<br />Center
                </SortableHeaderComponent>,
            width: 120,
            sortable: true,
            resizable: true
        },
        {
            colId: 'donorIsExportable',
            field: 'donorIsExportable',
            headerName: 'Donor Exportable',
            cellClass: 'center-list-cell',
            headerClass: 'list-header',
            headerComponentFramework: (props: IHeaderParams) =>
                <SortableHeaderComponent {...props}>
                    Donor<br />Exportable
                </SortableHeaderComponent>,
            width: 100,
            sortable: true,
            resizable: true,
            cellRendererFramework: (props: ICellRendererParams) => {
                let data = props.data as ILateRexmCompliance;

                if (data.donorIsExportable) {
                    return <Glyphicon glyph='ok' />
                }

                return null;
            }
        },
        {
            colId: 'donorAlias',
            field: 'donorAlias',
            headerName: 'Donor Alias',
            cellClass: 'center-list-cell',
            headerClass: 'list-header-right',
            headerComponentFramework: (props: IHeaderParams) =>
                <SortableHeaderComponent {...props}>
                    Donor<br />Alias
                </SortableHeaderComponent>,
            width: 100,
            sortable: true,
            resizable: true
        },
        {
            colId: 'recipientCenterAlias',
            field: 'recipientCenterAlias',
            headerName: 'Recipient Center',
            cellClass: 'center-list-cell',
            headerClass: 'center-list-header',
            width: 105,
            headerComponentFramework: (props: IHeaderParams) =>
                <SortableHeaderComponent {...props}>
                    Recipient<br />Center
                </SortableHeaderComponent>,
            sortable: true,
            resizable: true
        },
        {
            colId: 'recipientAlias',
            field: 'recipientAlias',
            headerName: 'Recipient Alias',
            cellClass: 'center-list-cell',
            headerClass: 'center-list-header',
            headerComponentFramework: (props: IHeaderParams) =>
                <SortableHeaderComponent {...props}>
                    Recipient<br />Alias
                </SortableHeaderComponent>,
            width: 120,
            sortable: true,
            resizable: true
        },
        {
            colId: 'recipientIsExportable',
            field: 'recipientIsExportable',
            headerName: 'Recipient Exportable',
            cellClass: 'center-list-cell',
            headerClass: 'center-list-header',
            headerComponentFramework: (props: IHeaderParams) =>
                <SortableHeaderComponent {...props}>
                    Recipient<br />Exportable
                </SortableHeaderComponent>,
            width: 120,
            sortable: true,
            resizable: true,
            cellRendererFramework: (props: ICellRendererParams) => {
                let data = props.data as ILateRexmCompliance;

                if (data.recipientIsExportable) {
                    return <Glyphicon glyph='ok' />
                }

                return null;
            }
        },
        {
            colId: 'dateRequested',
            field: 'dateRequested',
            headerName: 'Date Requested',
            cellClass: 'center-list-cell',
            headerClass: 'center-list-header',
            headerComponentFramework: (props: IHeaderParams) =>
                <SortableHeaderComponent {...props}>
                    Date<br />Requested
                </SortableHeaderComponent>,
            width: 120,
            sortable: true,
            resizable: true,
            cellRendererFramework: (props: ICellRendererParams) => { return moment(props.value).format('MM/DD/YYYY'); }
        },
        {
            colId: 'expectedResponseDate',
            field: 'expectedResponseDate',
            headerName: 'Expect Resp Date',
            cellClass: 'center-list-cell',
            headerClass: 'center-list-header',
            headerComponentFramework: (props: IHeaderParams) =>
                <SortableHeaderComponent {...props}>
                    Expected<br /> Response Date
                </SortableHeaderComponent>,
            width: 130,
            sortable: true,
            resizable: true,
            cellRendererFramework: (props: ICellRendererParams) => { return moment(props.value).format('MM/DD/YYYY hh:mm'); }

        },
        {
            colId: 'responseDateTime',
            field: 'responseDateTime',
            headerName: 'Response Date',
            cellClass: 'center-list-cell',
            headerClass: 'center-list-header',
            headerComponentFramework: (props: IHeaderParams) =>
                <SortableHeaderComponent {...props}>
                    Response<br />Date
                </SortableHeaderComponent>,
            width: 130,
            sortable: true,
            resizable: true,
            cellRendererFramework: (props: ICellRendererParams) => { 
                if(!moment(props.value).isValid()) {
                    return "-"
                }
                return moment(props.value).format('MM/DD/YYYY hh:mm'); 
            }
        },

        {
            colId: 'responseDetails',
            field: 'responseDetails',
            headerName: 'Response Details',
            cellClass: 'center-list-cell',
            headerClass: 'center-list-header',
            width: 140,
            headerComponentFramework: (props: IHeaderParams) =>
                <SortableHeaderComponent {...props}>
                    Response<br />Details
                </SortableHeaderComponent>,
            cellRendererFramework: (props: ICellRendererParams) =>
                <div>
                    <OverlayTrigger trigger={['hover', 'focus']} placement='bottom' overlay={getOverlay(props.data.id)}>
                        <div>
                            {props.data.responseDetails.substring(0, 15)}...
                        </div>
                    </OverlayTrigger>
                </div>,
            sortable: true,
            resizable: true

        },
        {
            colId: 'safeKey',
            field: 'safeKey',
            headerName: 'Safe Key',
            cellClass: 'center-list-cell',
            headerClass: 'center-list-header',
            headerComponentFramework: (props: IHeaderParams) =>
                <SortableHeaderComponent {...props}>
                    Safe Key
                </SortableHeaderComponent>,
            width: 160,
            sortable: true,
            resizable: true,
            hide: true
        },
        {
            colId: 'secondsLate',
            field: 'secondsLate',
            headerName: 'Seconds Late',
            cellClass: 'center-list-cell',
            headerClass: 'center-list-header',
            headerComponentFramework: (props: IHeaderParams) =>
                <SortableHeaderComponent {...props}>
                    Seconds <br />Late
                </SortableHeaderComponent>,
            width: 80,
            sortable: true,
            resizable: true,
            hide: true
        },
        {
            colId: 'isLate',
            field: 'isLate',
            headerName: 'Is Late',
            cellClass: 'center-list-cell',
            headerClass: 'center-list-header',
            headerComponentFramework: (props: IHeaderParams) =>
                <SortableHeaderComponent {...props}>
                    Late
                </SortableHeaderComponent>,
            width: 80,
            sortable: true,
            resizable: true,
            cellRendererFramework: (props: ICellRendererParams) => {
                let data = props.data as ILateRexmCompliance;

                if (data.isLate) {
                    return <Glyphicon glyph='ok' />
                }

                return null;
            }
        },
        {
            colId: 'isPending',
            field: 'isPending',
            headerName: 'Is Pending',
            cellClass: 'center-list-cell',
            headerClass: 'center-list-header',
            headerComponentFramework: (props: IHeaderParams) =>
                <SortableHeaderComponent {...props}>
                    Pending
                </SortableHeaderComponent>,
            width: 80,
            sortable: true,
            resizable: true,
            cellRendererFramework: (props: ICellRendererParams) => {
                let data = props.data as ILateRexmCompliance;

                if (data.isPending) {
                    return <Glyphicon glyph='ok' />
                }

                return null;
            }
        },
        {
            colId: 'daysLate',
            field: 'daysLate',
            headerName: 'Days Late',
            cellClass: 'center-list-cell',
            headerClass: 'center-list-header',
            headerComponentFramework: (props: IHeaderParams) =>
                <SortableHeaderComponent {...props}>
                    * Days<br />Late
                </SortableHeaderComponent>,
            width: 70,
            sortable: true,
            resizable: true
        }
    ];

    const columnDefs = useMemo(() => reportColumns, [props.data]);
    const rowData = useMemo(() => props.data, [props.data]);

    return (
        <GridWrapper id='grid-wrapper' className='container-fluid-max-sm ag-theme-bootstrap' style={{ marginBottom: 20 }}>
            <AgGridReact
                columnDefs={columnDefs}
                rowData={rowData}
                enableCellTextSelection={true}
                enableRangeSelection={true}
                headerHeight={44}
                noRowsOverlayComponentFramework={() => <div>No data for the selected date range...</div>}
                suppressCellSelection={true}
                onGridReady={onGridReady}
                onFirstDataRendered={onFirstDataRendered}
                onRowDataChanged={onRowDataChanged}
                onSortChanged={onSortChanged}
            />
        </GridWrapper>
    );
}

export default Grid;